import createSelector from 'selectorator'
import { identity, path, pathOr } from 'ramda'
import { NAMESPACE } from '../constants'

export const notificationCentreState = createSelector([identity], s => path([NAMESPACE], s))

export const getNotifications = createSelector([notificationCentreState], pathOr([], ['notifications']))
